<template>
  <div id="app">
    <router-view></router-view>
    <el-dialog
      class="pcDialog"
      :close-on-click-modal="false"
      title="提示"
      :visible.sync="dialogShow"
      width="250px">
      <span>不支持移动端，请在电脑端查看</span>
      <span slot="footer">
        <!-- <el-button @click=" = false">Cancel</el-button> -->
        <!-- <el-button type="primary" @click="">OK</el-button> -->
      </span>
    </el-dialog>

  </div>

</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      dialogShow: false
    }
  },
  computed: {
    locationUrl () {
      return process.env.H5_PATH
    }
  },
  methods: {
    isMobile () {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        const href = window.location.href
        let path = ''
        if (href.indexOf('video') > -1) {
          path = '/courseDetail' + href.substring(href.lastIndexOf('/'))
        }
        window.location.href = this.locationUrl + path
      }
    }
  },
  created () {

  },
  mounted () {
    this.isMobile()
  }
}
</script>

<style lang="scss">
#app {
  /* font-family: 'PingFang SC','Avenir', Helvetica, Arial, sans-serif; */
  color: #333;
}
body {
  margin: 0px;
  font-family: Source Han Sans CN;
}

a {
  text-decoration: none;
  color:#333;
}

ul {
  list-style: none;
  padding-left: 0;

}
.el-tree{
  padding: 20px;
  box-sizing: border-box;
}
.el-tree span{
  font-size: 14px;
}
.el-tree-node__children span:before{
  width: 5px;
  height: 5px;
  background: #979797;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}
// 提示弹窗
.pcDialog {
  .el-dialog__headerbtn{
  display:none;
}
.el-dialog__header{
  text-align:center
}
}
// 按钮
.el-button--primary{
  border-color: #26bf9b;
  background-color: #26bf9b;
  &:hover{
    border-color: #00a47d;
    background-color: #00a47d;
  }
}
.el-breadcrumb__inner.is-link:hover{
  color:#00a47d
}
// 分页
.el-pagination.is-background .btn-prev, .el-pagination.is-background .btn-next{
      padding:0px 7px;
}
//   .btn-prev{
//       background-color: #fff;
//       height: 35px;
//       width: 100px;
//       color: #666;
//       span{
//         height: 100%;
//         line-height: 35px;
//       }
//       &:disabled{
//         height: 35px;
//         background-color: #f4f4f5;
//       }
//     }
// .btn-next{
//       background-color: #fff;
//       height: 35px;
//       width: 100px;
//       color: #666;
//       span{
//         height: 100%;
//         line-height: 35px;
//       }
//       &:disabled{
//         height: 35px;
//         background-color: #f4f4f5;
//       }
//     }
// .el-pager{
//       li{
//         height: 35px;
//         width: 35px;
//         line-height: 35px;
//         background-color: #fff;
//         color: #666;
//         margin: 0 8px;
//         &:hover{
//           color:#26BF9B;
//         }
//       }
//       li:not(.disabled).active{
//          background-color: #26BF9B!important;
//          color: #fff;
//       }
//     }
// .el-pagination.is-background .el-pager li:not(.disabled):hover{
//       color:#26BF9B;
//     }
</style>



// WEBPACK FOOTER //
// src/App.vue